import { render, staticRenderFns } from "./CrmContactsPad.vue?vue&type=template&id=c186a6a4&scoped=true"
import script from "./CrmContactsPad.vue?vue&type=script&lang=js"
export * from "./CrmContactsPad.vue?vue&type=script&lang=js"
import style0 from "./CrmContactsPad.vue?vue&type=style&index=0&id=c186a6a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c186a6a4",
  null
  
)

export default component.exports